import { loading, masterData } from "../store/store";
import client from "./client";
export const getMasterData = async () => {
    try {
        loading.set(true);
        const res = await client("/v1/masterDatas", {
            method: "GET",
            version: "Vehicle",
        });
        loading.set(false);
        return res;
    }
    catch (error) {
        console.log(error.response);
        loading.set(false);
        // errorMessage.set(error);
        return error;
    }
};
export const getEvMasterData = async () => {
    try {
        loading.set(true);
        const res = await client("/v1/masterData", {
            method: "GET",
            version: "evCharging",
        });
        loading.set(false);
        return res;
    }
    catch (error) {
        console.log(error.response);
        loading.set(false);
        // errorMessage.set(error);
        return error;
    }
};
export async function cachedMasterData() {
    try {
        const res = await getMasterData();
        masterData.set(res.data);
    }
    catch (error) {
        console.log(error);
    }
}
